import Joi from "joi";
import { Logger } from "./logger";

export const LocalizedJoi = Joi.defaults((schema) =>
  schema.options({
    // abortEarly: false,
    messages: {
      //GENERELLT
      //   "any.custom": "{{#label}} failed custom validation because {{#error.message}}",
      //   "any.default": "{{#label}} threw an error when running default method",
      //   "any.failover": "{{#label}} threw an error when running failover method",
      "any.invalid": "{{#label}} er ugyldig",
      "any.only": '{{#label}} must be {if(#valids.length == 1, "", "one of ")}{{#valids}}',
      //   "any.ref": "{{#label}} {{#arg}} references {{:#ref}} which {{#reason}}",
      "any.required": "{{#label}} er påkrevd",
      "any.unknown": "{{#label}} er ikke tillatt",
      //   "string.uri": "{{#label}} must be a valid uri",
      //   "string.uriCustomScheme": "{{#label}} must be a valid uri with a scheme matching the {{#scheme}} pattern",
      //   "string.uriRelativeOnly": "{{#label}} must be a valid relative uri",
      //   "string.uppercase": "{{#label}} must only contain uppercase characters",
      //DATO
      "date.base": "{{#label}} må være en gyldig dato",
      "date.format": '{{#label}} må være i følgende format {msg("date.format." + #format) || #format}',
      "date.greater": "{{#label}} må være etter {{:#limit}}",
      "date.less": "{{#label}} må være før {{:#limit}}",
      "date.max": "{{#label}} må være før {{:#limit}}",
      "date.min": "{{#label}} må være etter {{:#limit}}",
      // Messages used in date.format
      //   'date.format.iso': 'ISO 8601 date',
      //   'date.format.javascript': 'timestamp or number of milliseconds',
      //   'date.format.unix': 'timestamp or number of seconds'
      //joi-phone-number
      "phoneNumber.invalid": "Ugyldig telefonnummer",
      //STRING
      "string.alphanum": "{{#label}} skal bare inneholde bokstaver og tall",
      "string.base": "{{#label}} must be a string",
      //   "string.base64": "{{#label}} must be a valid base64 string",
      //   "string.creditCard": "{{#label}} must be a credit card",
      //   "string.dataUri": "{{#label}} must be a valid dataUri string",
      //   "string.domain": "{{#label}} must contain a valid domain name",
      "string.email": "{{#label}} er ugyldig",
      "string.empty": "{{#label}} er påkrevd",
      //   "string.guid": "{{#label}} must be a valid GUID",
      //   "string.hex": "{{#label}} must only contain hexadecimal characters",
      //   "string.hexAlign": "{{#label}} hex decoded representation must be byte aligned",
      //   "string.hostname": "{{#label}} must be a valid hostname",
      //   "string.ip": "{{#label}} must be a valid ip address with a {{#cidr}} CIDR",
      //   "string.ipVersion":
      //     "{{#label}} must be a valid ip address of one of the following versions {{#version}} with a {{#cidr}} CIDR",
      //   "string.isoDate": "{{#label}} must be in iso format",
      //   "string.isoDuration": "{{#label}} must be a valid ISO 8601 duration",
      "string.length": "{{#label}} må være {{#limit}} tegn",
      //   "string.lowercase": "{{#label}} must only contain lowercase characters",
      "string.max": "{{#label}} kan maks være {{#limit}} tegn",
      "string.min": "{{#label}} må minst være {{#limit}} tegn",
      //   "string.normalize": "{{#label}} must be unicode normalized in the {{#form}} form",
      //   "string.token": "{{#label}} must only contain alpha-numeric and underscore characters",
      "string.pattern.base": "{{#label}} with value {:[.]} fails to match the required pattern: {{#regex}}",
      //   "string.pattern.name": "{{#label}} with value {:[.]} fails to match the {{#name}} pattern",
      //   "string.pattern.invert.base": "{{#label}} with value {:[.]} matches the inverted pattern: {{#regex}}",
      //   "string.pattern.invert.name": "{{#label}} with value {:[.]} matches the inverted {{#name}} pattern",
      "string.trim": "{{#label}} kan ikke starte eller slutte på mellomrom",
    },
  }),
);

export function validateJoiField(data: unknown, fieldName: string, schema: Joi.Schema) {
  if (!schema) {
    return LocalizedJoi.object().validate(data);
  }
  try {
    return LocalizedJoi.object(schema.extract(fieldName)).validate(data);
  } catch (error) {
    Logger.error(error);

    return LocalizedJoi.object().validate(data);
  }
}
